<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <path
      d="M28.2759 24.1201H26.9592L26.4926 23.6701C28.4926 21.3367 29.5259 18.1534 28.9592 14.7701C28.1759 10.1367 24.3092 6.45341 19.6592 5.87008C13.3426 5.08675 7.94258 9.75341 7.49258 15.7867H10.8592C11.2592 12.2534 14.0592 9.45341 17.6259 9.15341C21.8592 8.78675 25.7759 12.3701 25.7759 16.6201C25.7759 20.7701 22.4259 24.1201 18.2759 24.1201C17.9926 24.1201 17.7259 24.0701 17.4426 24.0367V27.4034C17.4426 27.4034 17.4426 27.4034 17.4592 27.4201C20.4592 27.6367 23.2426 26.6367 25.3259 24.8368L25.7759 25.3034V26.6201L32.8592 33.7034C33.5426 34.3868 34.6592 34.3868 35.3426 33.7034C36.0259 33.0201 36.0259 31.9034 35.3426 31.2201L28.2759 24.1201Z"
      fill="url(#paint0_linear_13752_29545)"
    />
    <path
      d="M12.6426 19.4034L9.10924 22.9368L5.57591 19.4034C5.24258 19.0701 4.72591 19.0701 4.39258 19.4034C4.05924 19.7367 4.05924 20.2534 4.39258 20.5867L7.92591 24.1201L4.39258 27.6534C4.05924 27.9868 4.05924 28.5034 4.39258 28.8368C4.72591 29.1701 5.24258 29.1701 5.57591 28.8368L9.10924 25.3034L12.6426 28.8368C12.9759 29.1701 13.4926 29.1701 13.8259 28.8368C14.1592 28.5034 14.1592 27.9868 13.8259 27.6534L10.2926 24.1201L13.8259 20.5867C14.1592 20.2534 14.1592 19.7367 13.8259 19.4034C13.4926 19.0867 12.9759 19.0867 12.6426 19.4034Z"
      fill="url(#paint1_linear_13752_29545)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_13752_29545"
        x1="4.14258"
        y1="5.78406"
        x2="32.523"
        y2="37.2238"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" stop-color="#DF252A" />
        <stop offset="1" stop-color="#A20004" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_13752_29545"
        x1="4.14258"
        y1="5.78406"
        x2="32.523"
        y2="37.2238"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" stop-color="#DF252A" />
        <stop offset="1" stop-color="#A20004" />
      </linearGradient>
    </defs>
  </svg>
</template>
